import { useState, useEffect } from 'react';

import { getFromClient } from './getFromClient';
import { AppSettings } from './dev';

export const useAppSettings = () => {
  const [appSettings, setAppSettings] = useState<AppSettings | null>(null);

  useEffect(() => {
    const fetchAppSettings = async () => {
      const settings = await getFromClient();
      setAppSettings(settings);
    };

    fetchAppSettings();
  }, []);

  return appSettings;
};
